<section class="pt-2 ">
  <div class="container-style">
    <div class="row align-items-center pb-2">
      <div class="col-lg-6 col-md-12 col-sm-12 col-12">
        <h6>
          {{ isFormView ? 'Registrar detalle de entrada de inventario' : 'Detalle de entrada de inventario' }}
        </h6>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
        <div class="d-flex gap-2">
          <app-custom-button [title]="'Importar'" [severity]="'primary'" [icon]="'pi pi-file-import'"
            [disabled]="disabledImportButton" (onClick)="openImportModal()"></app-custom-button>

          <app-custom-modal #importDetail [label]="'Seleccionar'" [header]="'Importar Detalle'" [width]="'50vw'"
            [children]="componentImport" [inputs$]="inputsForImport$" [output$]="outputForImport$"
            (selectedItems)="handleSelectedItem()" hidden></app-custom-modal>

          <app-custom-button [label]="'Nuevo Detalle'" [severity]="'success'" [disabled]="disabledButton"
            [width]="'7rem'" (onClick)="createNewDetail()"></app-custom-button>
        </div>
      </div>
    </div>
    <div class="row mx-0" [hidden]="!isFormView">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
        <app-register-inventory-entry-detail [inventoryEntryDetailContract]="inventoryEntryDetail"
          [inventoryEntryContract]="inventoryEntryModel" [disabled]="disabledDetail"
          (updateListDetail)="getInventoryEntryDetailsByInventoryEntry()" (isFormView)="getFormView($event)">
        </app-register-inventory-entry-detail>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
      <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
        [showCheckbox]=" !this.disabledButton " [checkBoxAction]="checkboxActions"
        [clearSelectionTrigger]="clearSelectionTrigger" (onRecoverData)="getInventoryEntryDetailsByInventoryEntry()"
        (onPageChange)="onPageChange($event)" (onAction)="onAction($event)">
      </app-custom-table>
    </div>
  </div>
</section>